import { render, staticRenderFns } from "./book.vue?vue&type=template&id=a71ba308&scoped=true"
import script from "./book.vue?vue&type=script&lang=js"
export * from "./book.vue?vue&type=script&lang=js"
import style0 from "./book.vue?vue&type=style&index=0&id=a71ba308&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a71ba308",
  null
  
)

export default component.exports